module.exports = __webpack_public_path__ + "img/img23.147b5c13.jpg";